import React from 'react';
import { motion } from 'framer-motion';
import { Check, Globe, Lock, Shield, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, comboIncludes, ctaLabels, heroImage, price, trackCheckout } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-section relative border-y border-line" data-id="element-177" data-mp="1j9gzgtubtlbh">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-178" data-mp="1nasmqspq9ugi">
        <div className="text-center mb-12" data-id="element-179" data-mp="1naamzm3uwy3u">
          <h2 className="text-3xl md:text-5xl font-display font-bold mb-3 text-white" data-id="element-180" data-mp="1s93yxa3hwh1w">
            Your complete offer today
          </h2>
          <p className="text-gold font-display tracking-widest text-sm md:text-base uppercase" data-id="element-181" data-mp="1x99ie2zm2x8w">
            6 complete volumes. One complete coaching system.
          </p>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-card border border-gold/70 rounded-3xl relative shadow-[0_30px_60px_-30px_rgba(0,0,0,0.9)]" data-id="element-182" data-mp="2w0j140s4s4d">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-canvas font-bold px-5 py-1.5 rounded-full uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-183" data-mp="1hnvckutoofby">
            <Sparkles size={14} aria-hidden="true" data-id="element-184" data-mp="17pxllzkfw4fn" /> Complete System
          </div>
          <div className="p-6 md:p-10 text-center" data-id="element-185" data-mp="25er7i0tfrqnf">
            <img src={heroImage} alt="Boxing Coach Ready 6-in-1 box set" className="w-full max-w-[240px] h-auto object-contain mx-auto mt-2 mb-6" data-id="element-186" data-mp="20g67o2i3j8zi" />
            <h3 className="text-2xl md:text-3xl font-display font-bold text-white mb-2" data-id="element-187" data-mp="1rgj3j8xzfp2r">
              Boxing Coach Ready
            </h3>
            <p className="text-base text-mist mb-6" data-id="element-188" data-mp="k3itp1gh6j4q">
              The complete professional boxing coaching system.
            </p>
            <ul className="text-left max-w-md mx-auto space-y-2 mb-8 bg-canvas border border-line rounded-xl p-5" data-id="element-189" data-mp="hhrqwryiknki">
              {comboIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-mist" data-id="element-190" data-mp="mg3339ca7a5w">
                  <Check size={16} className="text-gold shrink-0 mt-0.5" aria-hidden="true" data-id="element-191" data-mp="7isldi91p81q" />
                  <span data-id="element-192" data-mp="chdih8t03bly">{item}</span>
                </li>)}
            </ul>
            <div className="mb-6" data-id="element-193" data-mp="3uvmrnv20c4em">
              <div className="flex flex-wrap items-baseline justify-center gap-3" data-id="element-194" data-mp="3uul5aufjjvhl">
                <span className="text-2xl md:text-3xl text-white font-display font-semibold" data-id="element-195" data-mp="3jjow5mmew2h">
                  TODAY:
                </span>
                <span className="text-5xl md:text-6xl font-display font-bold text-gold" data-id="element-196" data-mp="3pxl16p2952t4">
                  {price.today}
                </span>
              </div>
            </div>
            <p className="font-display text-white tracking-widest text-sm uppercase mb-1" data-id="element-197" data-mp="3c064r0dkzurn">
              Ready-to-use training material
            </p>
            <p className="text-steel text-sm mb-5" data-id="element-198" data-mp="2xc4qb8kivi2a">Open the page. Teach the session.</p>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-199" data-mp="2scs50s9auj1t">
              {ctaLabels.pricing}
            </Button>
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-steel mb-4" data-id="element-200" data-mp="3g9z6q7nzcvup">
              <span className="flex items-center gap-1.5" data-id="element-201" data-mp="3baw40tvh31pw">
                <Lock size={12} className="text-gold" aria-hidden="true" data-id="element-202" data-mp="3bacrjsold5j9" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-203" data-mp="3p4dkg5sv3ybp">
                <Zap size={12} className="text-gold" aria-hidden="true" data-id="element-204" data-mp="3l1qobsp5rr8p" /> Instant access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-205" data-mp="2vuh5kb6hdwh">
                <Shield size={12} className="text-gold" aria-hidden="true" data-id="element-206" data-mp="3u1m3s9pqy8ej" /> 7-day guarantee
              </span>
            </div>
            <div className="border border-line rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-207" data-mp="hx1biwktdijl">
              <Globe className="text-gold shrink-0 mt-0.5" size={14} aria-hidden="true" data-id="element-208" data-mp="ly4pfdjax4i6" />
              <p className="text-[11px] text-steel leading-snug" data-id="element-209" data-mp="qrpfmjenku6t">
                Pay in your local currency according to the options available through your payment
                provider.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}